// extracted by css-extract-rspack-plugin
export default {"regimen-finder":"RegimenFinder-module__regimen-finder--Mg0Hr"};